import { observer } from 'mobx-react';
import React from 'react';

import { addCanBeSelected } from '@helpers/shared';
import { useRootAppStore } from '@hooks';

import WalletItem from './WalletItem';
import { UserBalanceDisplayProps } from './types';

export default observer(function UserBalanceDisplay({
	isInMenu,
}: UserBalanceDisplayProps) {
	const rootStore = useRootAppStore();

	if (!rootStore.userAuthStore.userAccounts) {
		return null;
	}

	const userWalletsMapped = addCanBeSelected(rootStore.userAuthStore);

	const numberOfWallets = userWalletsMapped?.length;

	if (!isInMenu) {
		const wallet =
			userWalletsMapped.find(
				(account) =>
					account.id === rootStore.userAuthStore.activeWalletId
			) || userWalletsMapped[0];

		return (
			<WalletItem
				isInMenu={isInMenu}
				wallet={wallet}
				numberOfWallets={numberOfWallets}
			/>
		);
	}

	return (
		<>
			{userWalletsMapped.map((wallet) => {
				return (
					<WalletItem
						key={wallet.id}
						isInMenu={isInMenu}
						wallet={wallet}
						numberOfWallets={numberOfWallets}
					/>
				);
			})}
		</>
	);
});
